export const unitDetails = {
  'Unit not found': '¡Unidad no encontrada!',
  'The page for the unit you searched for was not found Try searching for other units by clicking the link below':
    'La página de la unidad que buscaste no fue encontrada. Intenta buscar otras unidades haciendo clic en el enlace de abajo.',
  'Search units': 'Buscar unidades',

  'Vialaser - Clinic {{unit}}': 'Vialaser - Clínica {{unit}}',
  'At this location, we serve clients in the <2>{{city}} - {{state}}</2> region, offering a welcoming environment and personalized service Schedule your consultation and discover the benefits of permanent laser hair removal':
    'En esta unidad, atendemos a clientes de la región de <2>{{city}} - {{state}}</2>, ofreciendo un ambiente acogedor y un servicio personalizado. Agenda tu evaluación y descubre los beneficios de la depilación láser permanente.',

  Address: 'Dirección',
  'See in the map': 'Ver en el mapa',

  Contact: 'Contacto',
  'Message in WhatsApp': 'Contactar por WhatsApp',

  'Service Hours': 'Horarios',

  Services: 'Servicios',
  'Laser hair removal for Women': 'Depilación láser femenina',
  'Laser hair removal for Man': 'Depilación láser masculina',

  'Vialaser advantages': 'Ventajas de Vialaser',

  'Advanced technology': 'Tecnología avanzada',
  "The world's first square tip, covering more area in less session time and without misses":
    'La primera punta cuadrada del mundo, que cubre más área en menos tiempo de sesión y sin fallas.',

  Painless: 'Menos dolor',
  'Laser with dual cooling ensures the most painless application on the market and a cool, refreshing feeling on the skin during treatment':
    'El láser con doble enfriamiento garantiza la aplicación más indolora del mercado y una sensación fresca y refrescante en la piel durante el tratamiento.',

  'For all kinds of skin colors': 'Para todo tipo de tonos de piel',
  'We combine two laser technologies: Alexandrite and Nd:YAG This guarantees excellent results on all skin tones':
    'Combinamos dos tecnologías láser: Alexandrite y Nd:YAG. Esto garantiza excelentes resultados en todos los tonos de piel.',

  Loading: 'Cargando...',
  'I need to talk to Vialaser customer service':
    'Necesito hablar con el servicio de atención al cliente de Vialaser.',
};
